import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement('path', { d: 'M16.35 28.68a.66.66 0 0 1-.45-.18l-2.77-2.6a.65.65 0 0 1 0-.9l1.23-1.42-1.7-1.36a.65.65 0 0 1-.25-.48.7.7 0 0 1 .2-.5l1.52-1.48-1.62-1.2a.66.66 0 0 1-.25-.68l.42-1.88a6.76 6.76 0 1 1 6.93-.16v9.59a.64.64 0 0 1-.19.46l-2.62 2.6a.65.65 0 0 1-.45.19zm-1.87-3.3l1.85 1.74 2-2V15.5a.65.65 0 0 1 .33-.61 5.47 5.47 0 1 0-4.94.17.64.64 0 0 1 .36.74l-.47 2 1.88 1.4a.64.64 0 0 1 .07 1L14 21.66 15.66 23a.65.65 0 0 1 .08.94z' }),
  React.createElement('path', { d: 'M18.12 12.67l-.83-1a2 2 0 1 0-2.58 0l-.83 1a3.34 3.34 0 1 1 4.24 0z' })
));